import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { isNullOrUndefined } from '@maplecroft-typescript/utils';

@Pipe({
  name: 'highlight',
  standalone: false,
})
export class HighlightSearchPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string | undefined, query: string | undefined, onlyFirstMatch: boolean = true): SafeHtml {
    if (!query || isNullOrUndefined(value)) {
      return value ?? '';
    }

    // Match in a case insensitive manner
    // nosemgrep: javascript.lang.security.audit.detect-non-literal-regexp.detect-non-literal-regexp
    const re = new RegExp(query, onlyFirstMatch ? 'i' : 'gi');
    const match = value.match(re);

    // If there's no match, just return the original value.
    if (!match) {
      return value;
    }

    const value2 = value.replace(re, '<b style="color: black !important;">' + match[0] + '</b>');

    return this.sanitizer.bypassSecurityTrustHtml(value2);
  }
}
